/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * Restore Firestore-like timestamps/refs after JSON.parse from branded-report API.
 */
export const reviveFirestoreJson = (value: unknown): any => {
  if (value === null || value === undefined) return value
  if (typeof value !== 'object') return value
  if (Array.isArray(value)) return value.map(reviveFirestoreJson)
  const o = value as Record<string, unknown>
  if (o.__fsTs === true && typeof o.seconds === 'number') {
    const seconds = o.seconds as number
    const nanoseconds = typeof o.nanoseconds === 'number' ? o.nanoseconds : 0
    return {
      seconds,
      nanoseconds,
      toDate: () => new Date(seconds * 1000 + nanoseconds / 1e6)
    }
  }
  if (o.__fsRef === true && typeof o.path === 'string') {
    const path = o.path as string
    const segments = path.split('/').filter(Boolean)
    return {
      path,
      id: segments.length ? segments[segments.length - 1] : '',
      _key: { path: { segments } }
    }
  }
  const out: Record<string, unknown> = {}
  for (const [k, v] of Object.entries(o)) {
    out[k] = reviveFirestoreJson(v)
  }
  return out
}
